<script setup>
  import { useLocale } from 'vuetify'
  const { t } = useLocale()
</script>
<template>
  <div class="w-100" :key="locale" v-if="primary">
      <div id="animatedlogo" class="pa-5 slide-out-top text-center bordered-app-bar-bottom bg-black">
        <v-img 
          src="@/assets/loghi/logotipo-2.svg"
          width="100%"
          class="mx-auto"
          max-width="280px"
          contain
          :alt="$env.VITE_APP_BASE_NAME">
        </v-img>
      </div>
      <v-app-bar height="75" class="bordered-app-bar-bottom bg-black">
        <template v-slot:prepend>
          <div class="d-flex align-center">
            <router-link :to="'/'+locale" class="d-inline-block d-lg-none">
              <v-img 
                src="@/assets/loghi/logotipo-2.svg"
                height="55"
                width="230"
                contain
                class="ml-6"
                :alt="$env.VITE_APP_BASE_NAME">
              </v-img>
              <!-- <v-img 
                src="@/assets/loghi/monogramma.svg"
                height="55"
                width="55"
                contain
                :alt="$env.VITE_APP_BASE_NAME">
              </v-img> -->
            </router-link>
            <router-link :to="'/'+locale" class="d-none d-lg-inline-block">
              <v-img 
                src="@/assets/loghi/logotipo-2.svg"
                height="55"
                width="230"
                contain
                class="ml-6"
                :alt="$env.VITE_APP_BASE_NAME">
              </v-img>
            </router-link>
            <v-img 
              src="/logo-hertz.png"
              width="80"
              class="mx-3 d-none d-lg-inline-block"
              contain
              :alt="$env.VITE_APP_BASE_NAME">
            </v-img>
          </div>
        </template>
        
        <v-spacer></v-spacer>
        <div class="d-none d-lg-block" v-if="primary[locale]" style="margin-left: -240px">
          <v-btn-toggle rounded="0" v-if="primary">
            <v-btn 
              v-for="(item, i) in primary[locale].value" 
              :key="item.title+'-'+i"
              base-color="secondary"
              exact
              rounded="0"
              :to="item.route"
              color="primary"
              class="text-uppercase"
              variant="text"
              >
            {{item.title}}
            </v-btn>
            <v-btn
              :to="getRequestQuoteLink"
              rounded="0"
              exact
              variant="text"
              class="bg-secondary text-uppercase"
              >
              {{ t('commons.requestQuoteShort') }}
            </v-btn>
          </v-btn-toggle>
        </div>

        <template v-slot:append>
          <!-- <v-img 
            src="/logo-hertz.png"
            width="120"
            class="mx-3"
            contain
            :alt="$env.VITE_APP_BASE_NAME">
          </v-img> -->
          <!-- <v-divider
            :thickness="1"
            class="border-opacity-100"
            color="primary"
            vertical
          ></v-divider> -->
          <div class="d-none d-lg-block">
            <locale-chooser-drop-down></locale-chooser-drop-down>
          </div>
          <v-divider
            :thickness="1"
            class="border-opacity-100 "
            color="primary"
            vertical
          ></v-divider>
          <!-- <v-app-bar-nav-icon 
            color="primary" 
            variant="text"
            icon="mdi-account-circle" 
            id="buttonLogin" 
            title="buttonLogin"
            v-if="isAuthenticated"
            :to="{name:'account'}">
          </v-app-bar-nav-icon> -->
          
          <!-- <v-app-bar-nav-icon 
            color="primary" 
            variant="text"
            v-if="!isAuthenticated"
            icon="mdi-account-circle" 
            id="buttonAccount" 
            title="buttonAccount"
            :to="{name:'account.login'}">
          </v-app-bar-nav-icon> -->
          <v-app-bar-nav-icon 
          :icon="drawer ? 'mdi-close' : 'mdi-menu' " 
          variant="text" 
          class="mx-auto d-block d-lg-none" 
          id="buttonNavigationDrawer" 
          title="buttonNavigationDrawer"
          @click.stop="closeDrawer()">
          </v-app-bar-nav-icon>
          <!-- <v-divider
            :thickness="1"
            v-if="secondary"
            class="border-opacity-100 mx-auto d-none d-lg-block"
            color="primary"
            vertical
          ></v-divider> -->
          <v-app-bar-nav-icon
            class="mx-auto d-none d-lg-block"
            :icon="drawer ? 'mdi-close' : 'mdi-menu' " 
            @click.stop="drawerSecondary = !drawerSecondary"
            v-if="secondary">
          </v-app-bar-nav-icon>

        </template>
      <v-spacer></v-spacer>
    
    </v-app-bar>
    <v-navigation-drawer 
      location="top" 
      temporary  

      class="bordered-app-bar-bottom bg-black h-auto" 
      v-if="secondary" 
      v-model="drawerSecondary">
      <v-divider class="mb-2"></v-divider>
      <v-container fluid class="py-5">
        <v-row v-if="secondary[locale]">
         <v-col cols="12" md="3" v-for="(group, i) in secondary[locale].value" :key="i" v-show="(selectedGroupSecondary.length >= 1) ? selectedGroupSecondary.includes(group.title) : true ">
          <v-card class="h-100" >
            <v-list density="compact">
              <v-list-subheader>{{group.title}}</v-list-subheader>
              <v-divider></v-divider>
              <v-list-item  
                v-for="(item, i) in group.group" 
                :key="i" 
                density="compact"
                :title="item.title"
                :text="item.text"
                class="text-small"
                color="primary"
                :to="item.route"
              ></v-list-item>
            </v-list>
          </v-card>
         </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-navigation-drawer  
        v-model="drawer"
        location="right"
        class="bordered-app-bar-bottom bg-black"
        temporary>
        
        <v-divider class="mb-2"></v-divider>
        <v-list-item link 
            v-for="(item, i) in primary[locale].value" 
            :key="i" 
            :title="item.title"
            :text="item.title"
            class="text-h6 py-2"
            color="primary"
            :to="item.route"
          ></v-list-item>
          <v-divider></v-divider>
          
          <!-- <v-list-item
          color="primary"
          class="text-h6 my-4 py-2"
          title="My Primerent"
          v-if="isAuthenticated"
          :to="{name:'account'}"
          >
            <template v-slot:prepend>
              <v-icon color="primary" icon="mdi-account-circle"></v-icon>
            </template>

          </v-list-item>
          
          <v-list-item
          color="primary"
          class="text-h6 my-4 py-2"
          title="My Primerent"
          v-if="!isAuthenticated"
          :to="{name:'account.login'}"
          >
            <template v-slot:prepend>
              <v-icon color="primary" icon="mdi-account-circle"></v-icon>
            </template>

          </v-list-item> -->
          <!-- <v-divider></v-divider> -->
         <v-list-item class="text-center">
          <locale-chooser></locale-chooser>
         </v-list-item>
         <v-divider></v-divider>
          <div v-if="secondary">
            <v-list-item 
              link 
              compact
              v-for="(item, i) in secondary[locale].value" 
              :key="i" 
              :title="item.title"
              :text="item.title"
              @click="selectGroupSecondary(item.title)"
              class="py-1 text-small small"
              color="primary"
              ></v-list-item>
            </div>
    </v-navigation-drawer>
    <v-progress-linear 
      :v-if="loading" 
      height="1" 
      :indeterminate="loading" 
      role="progressbar" 
      id="progressbar-appbar" 
      title="progressbar-appbar"
      color="primary">
    </v-progress-linear>
  </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  import LocaleChooser from './LocaleChooser.vue';
  import LocaleChooserDropDown from './LocaleChooserDropDown.vue';

   export default {
     computed:{
      ...mapGetters({
          loading: 'loading/loading',
          isAuthenticated: 'driveAuth/isAuthenticated',
          hasSettings: 'settings/hasSettings',
          primary: 'settings/primary',
          secondary: 'settings/secondary',
      }),
      getRequestQuoteLink() {
        const uri = this.$vuetify.locale.current == 'it' ? '/it/ricerca/quotazione-personalizzata' : '/en/search/personalized-quote'
        return uri;
      }
     },
     components:{
        'locale-chooser': LocaleChooser,
          LocaleChooserDropDown,
      },
      data: () => ({
        selectedGroupSecondary: [],
        drawer: false,
        drawerSecondary: false,
        locale: localStorage.getItem('locale'),
      }),
      mounted(){
        this.drawer = false;
        if(!['en','it','pt'].includes(this.locale)){
          this.locale = 'en';
        }
        if(this.secondary){
          this.secondary[this.locale].value.forEach((item)=>{
            
            this.selectedGroupSecondary.push(item.title)
             
          })
        }
      },
      methods:{
        selectGroupSecondary(title){
          this.drawerSecondary = !this.drawerSecondary
          this.selectedGroupSecondary = [title]
        },
        closeDrawer(){
          this.drawer = (this.drawer) ? false : true;
          this.drawerSecondary = false
        }
      }
    }
  </script>
  <style scoped>

  .h-75 {
    height: 75px !important;
  }

  #animatedlogo{
    position: fixed;
    width: 100%;
    z-index: 100000;
  }
  .bordered-app-bar-bottom{
    border-bottom: 0.5px solid  rgb(var(--v-theme-primary)) !important
  }
  .bordered-app-bar-right{
    border-right: 2px solid  rgb(var(--v-theme-primary)) !important
  }
  .bordered-app-bar-left{
    border-left: 2px solid  rgb(var(--v-theme-primary)) !important
  }
  .v-btn--active{
    border-bottom: 1px solid  rgb(var(--v-theme-primary)) !important
  }
  
  .slide-out-top {
	-webkit-animation: slide-out-top 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) 1.2s both;
          animation: slide-out-top 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) 1.2s both;
  }

/* ----------------------------------------------
 * Generated by Animista on 2024-1-29 17:28:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-out-top
 * ----------------------------------------
 */
 @-webkit-keyframes slide-out-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px);
            transform: translateY(-1000px);
    opacity: 0;
  }
}
@keyframes slide-out-top {
  0% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px);
            transform: translateY(-1000px);
    opacity: 0;
  }
}

  </style>